import { takeLatest, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_GET_DOCUMENT_SUMMARY,
  SUCCESS_GET_DOCUMENT_SUMMARY,
  FAILURE_GET_DOCUMENT_SUMMARY,
  LOADING_GET_DOCUMENT_SUMMARY,
} = documentBundleActions;

function* getDocumentSummary(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_DOCUMENT_SUMMARY });
    const response = yield call(documentBundleService.getDocumentSummary, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_DOCUMENT_SUMMARY, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_DOCUMENT_SUMMARY, payload: error });
  }
}

function* getDocumentSummarySaga() {
  yield takeLatest(REQUEST_GET_DOCUMENT_SUMMARY, getDocumentSummary);
}

export default getDocumentSummarySaga;
export { getDocumentSummary };
